import { registerPlugin } from '@capacitor/core';
import { OnboardingDialog } from "@/native/plugins/OnboardingDialog/definitions";

const OnboardingDialog = registerPlugin<OnboardingDialog>('OnboardingDialog', {
  web: () => import('./web').then((m) => new m.OnboardingDialogWeb()),
});

export * from './definitions';
export { OnboardingDialog }
